export default {
      id: "magnifier-usage",
      viewBox: "0 0 20 19",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#magnifier",
      toString: function () {
        return this.url;
      }
    }